export default __webpack_public_path__ + "static/media/twitter.d2a42582.svg";